module.exports = __webpack_public_path__ + "static/img/lou.55b009b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lou.jpg
// module id = Nwsi
// module chunks = 1